/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import {
  Button,
} from '@material-ui/core';
import {
  completeNewPassword,
  selectIsPending,
} from '../../store/authSlice';
import {
  isRequired,
  passwordValidationRules,
  validateField,
  validateForm,
  noPasswordMismatch,
} from '../../helpers/validation';
import PasswordField from '../common/PasswordField';

const useStyles = makeStyles((theme) => ({
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function NewPasswordForm() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const isPending = useSelector(selectIsPending);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [formErrors, setFormErrors] = useState({});
  const [mismatchError, setMismatchError] = useState('');

  const formRules = {
    newPassword: [...passwordValidationRules],
  };

  const handleNewPasswordChange = (event) => {
    setNewPassword(event.target.value);
  };

  const handleConfirmPasswordChange = (event) => {
    setConfirmPassword(event.target.value);
  };

  const handleBlur = (event) => {
    validateField(formRules, formErrors, setFormErrors, event.target.name, event.target.value);
  };

  const validateNewPassword = () => {
    if (!isRequired.validate(confirmPassword)) {
      setMismatchError(isRequired.error);
      return false;
    }

    if (!noPasswordMismatch(newPassword).validate(confirmPassword)) {
      setMismatchError(noPasswordMismatch(newPassword).error);
      return false;
    }

    setMismatchError('');
    return true;
  };

  const attemptCompleteNewPassword = (event) => {
    event.preventDefault();
    if (validateForm(formRules, { newPassword }, formErrors, setFormErrors) && validateNewPassword()) {
      dispatch(completeNewPassword(newPassword));
    }
  };

  return (
    <form className={classes.form} noValidate>
      <PasswordField
        variant="outlined"
        margin="normal"
        name="newPassword"
        label="New Password"
        id="new-password"
        value={newPassword}
        error={!!formErrors.newPassword}
        helperText={formErrors.newPassword}
        onChange={handleNewPasswordChange}
        onBlur={handleBlur}
        disabled={isPending}
        fullWidth
        required
      />
      <PasswordField
        variant="outlined"
        margin="normal"
        name="confirm-password"
        label="Confirm Password"
        id="confirm-password"
        onChange={handleConfirmPasswordChange}
        onBlur={validateNewPassword}
        error={!!mismatchError}
        helperText={mismatchError}
        disabled={isPending}
        fullWidth
        required
      />
      <Button
        type="submit"
        variant="contained"
        color="primary"
        className={classes.submit}
        onClick={attemptCompleteNewPassword}
        disabled={isPending}
        fullWidth
      >
        Update Password
      </Button>
    </form>
  );
}
